import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Toast } from "discover.medical.react-component-library";

const DrugInteractionsErrorToast = ({ hasError, errorMessage }) => {
  const [isOpen, setIsOpen] = useState(hasError);

  const onClose = () => setIsOpen(false);
  useEffect(() => setIsOpen(hasError), [hasError]);

  return (
    <Toast isOpen={isOpen} onClose={onClose} type="error">
      {errorMessage}
    </Toast>
  );
};

DrugInteractionsErrorToast.displayName = "DrugInteractionsErrorToast";

DrugInteractionsErrorToast.propTypes = {
  hasError: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string.isRequired,
};

export default DrugInteractionsErrorToast;
